export default __webpack_public_path__ + "8f0c31988ad31dda346426eedf31a0f5.js";